import {Component, Input} from '@angular/core';

@Component({
  selector: 'mc-slack-notification',
  templateUrl: './slack-notification.component.html',
  styleUrls: ['./slack-notification.component.scss'],
})
export class SlackNotificationComponent {
  @Input() url: string;
  @Input() message: string;
}
